import { render } from "./addAccount.vue?vue&type=template&id=3cf05273"
import script from "./addAccount.vue?vue&type=script&lang=js"
export * from "./addAccount.vue?vue&type=script&lang=js"

import "./addAccount.vue?vue&type=style&index=0&id=3cf05273&lang=less"
script.render = render

export default script